/* eslint-disable import/prefer-default-export */
import React from 'react';
import { AnimatePresence } from 'framer-motion';

import * as Styled from 'topBar/styles/TopBarTitle.style';

interface TopBarTitleProps {
  title?: string;
  subtitle?: string;
  visible: boolean;
}

export function TopBarTitle({
  title,
  subtitle,
  visible,
}: TopBarTitleProps): JSX.Element {
  return (
    <AnimatePresence>
      {visible && (
        <Styled.Container
          key="topbar-title"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{
            duration: 0.2,
            ease: [0, 0, 0.2, 1],
          }}
        >
          {title && <Styled.Title>{title}</Styled.Title>}
          {subtitle && <Styled.Subtitle>{subtitle}</Styled.Subtitle>}
        </Styled.Container>
      )}
    </AnimatePresence>
  );
}
